import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=5ae9c420&scoped=true"
import script from "./ChatButton.vue?vue&type=script&lang=ts"
export * from "./ChatButton.vue?vue&type=script&lang=ts"
import style0 from "./ChatButton.vue?vue&type=style&index=0&id=5ae9c420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae9c420",
  null
  
)

export default component.exports